const pisOfflineAudioList = {
  bindings: {
    data: '<',
    filter: '<',
    loading: '<',
    modalOptions: '<',
    onToggle: '&'
  },
  templateUrl: '/modules/pis-tool/offline-audio/offline-audio-list/offline-audio-list.html',
  controller: 'PisOfflineAudioListController',
};

angular
  .module('offline.module')
  .component('pisOfflineAudioList', pisOfflineAudioList);
